import BaseService from "./base.service";
import { IFileAddResult } from "@pnp/sp/files";
import { Constants, Enums, String, Utilities } from "../../utils/utilities";
import { isFunc } from "@pnp/common";
import { IFileMetadata, IFileResponse } from "../../models";
import { IItems } from "@pnp/sp/items";

import "@pnp/sp/files";
import "@pnp/sp/folders";

export interface ISPFileService {
  uploadFile(
    file: File,
    metadata: IFileMetadata,
    progress?: any
  ): Promise<boolean>;
  deleteFile(fileRelativeUrl: string): Promise<boolean>;
  getFiles(proaSubprojectId: number): Promise<Array<IFileResponse>>;
  getAllFiles(listName: string): Promise<Array<IFileResponse>>;
}

export default class SPFileService extends BaseService

  implements ISPFileService {
  private readonly SIZE_10_MB: number = 10485760;

  public async uploadFile(file: File, metadata: IFileMetadata, progress?: any): Promise<boolean> {
    let fileUploaded: IFileAddResult;

    try {
      let spContext = await this.getSPContext();
      let siteUrl = await spContext.web.select("ServerRelativeUrl").get();
      let relativeUrl = `${siteUrl.ServerRelativeUrl}/${Enums.ListTypes.ProaDocumentsPost}`;
      if (file != null) {
        if (file.size <= this.SIZE_10_MB) {
          fileUploaded = await spContext.web
            .getFolderByServerRelativeUrl(relativeUrl)
            .files.add(
              `${metadata.Title}.${file.name.split(".")[1]}`,
              file,
              true
            );
        } else {
          if (!isFunc(progress)) progress = (): any => null;

          fileUploaded = await spContext.web
            .getFolderByServerRelativeUrl(relativeUrl)
            .files.addChunked(
              `${metadata.Title}.${file.name.split(".")[1]}`,
              file,
              progress,
              true
            );
        }
      }
      //metadata = Utilities.removeNullOrUndefinedValues(metadata);
      if (metadata) {
        let item = fileUploaded
          ? await fileUploaded.file.getItem()
          : await spContext.web.getFolderByServerRelativeUrl(relativeUrl).files.getByName(metadata.Title).getItem();
        await item.update(metadata);
      }

      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }
  public async deleteFile(fileRelativeUrl: string): Promise<boolean> {
    try {
      let spContext = await this.getSPContext();
      await spContext.web.getFileByServerRelativeUrl(fileRelativeUrl).recycle();
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }
  public async getFiles(
    proaSubprojectId: number
  ): Promise<Array<IFileResponse>> {
    try {
      let spContext = await this.getSPContext();
      let items: IItems = spContext.web.lists.getByTitle(
        Enums.ListTypes.ProaDocuments
      ).items;
      let filter: string;

      filter = String.Format(
        Constants.FiltersFormats.FILTER_PROA_DOCUMENTS_BY_FFRR_STEP1,
        proaSubprojectId
      );

      items = items.filter(filter);

      items = items
        .select(...Constants.Selects.SELECT_FILE_BY_ITEM)
        .expand(...Constants.Expands.SELECT_FILE_BY_ITEM_EXPAND);

      let itemsSPResponse: any[] = await items.get();
      let itemsResponse: Array<IFileResponse> = [];

      if (itemsSPResponse.length > 0) {
        itemsResponse = itemsSPResponse.map((element: any) => {
          return {
            File: {
              id: element.ID,
              Name: element.File.Name,
              ServerRelativeUrl: element.File.ServerRelativeUrl,
              UniqueId: element.File.UniqueId,
            },
            ServerRedirectedEmbedUri: element.EncodedAbsUrl,
          } as IFileResponse;
        });
      }

      return itemsResponse;
    } catch (error) {
      console.error(error);

      return [];
    }
  }
  public async getAllFiles(listName: string): Promise<Array<IFileResponse>> {
    try {
      let spContext = await this.getSPContext();
      let items: IItems = spContext.web.lists.getByTitle(listName).items;

      items = items
        .select(...Constants.Selects.SELECT_FILE_BY_ITEM)
        .expand(...Constants.Expands.SELECT_FILE_BY_ITEM_EXPAND);

      let itemsSPResponse: any[] = await items.get();

      let itemsResponse: Array<IFileResponse> = [];

      if (itemsSPResponse.length > 0) {
        itemsResponse = itemsSPResponse.map((element: any) => {
          return {
            File: {
              Name: element.File.Name,
              ServerRelativeUrl: element.File.ServerRelativeUrl,
              UniqueId: element.File.UniqueId,
            },
            ServerRedirectedEmbedUri: element.EncodedAbsUrl,
          } as IFileResponse;
        });
      }
      return itemsResponse;

    } catch (error) {
      console.error(error);

      return [];
    }
  }

  public getApplicationHelpFiles = async (application: string): Promise<{ OperationSuccess: boolean; Data: Array<any> }> => {
    try {
      let listName: string;

      switch (application.toUpperCase()) {
        case 'OCTAVIA':
          listName = Enums.ListTypes.OctaviaHelpLibrary;
          break;
        case 'PROYECTA':
          listName = Enums.ListTypes.UserHelpLibrary;
          break;
        case 'METACOFI':
          listName = Enums.ListTypes.CofiHelpLibrary;
          break;
        default:
          throw new Error('Aplicación no válida');
      }

      let spContext = await this.getSPContext();
      let items: IItems = spContext.web.lists.getByTitle(listName).items;

      items = items
        .select(...Constants.Selects.SELECT_FILE_BY_ITEM)
        .expand(...Constants.Expands.SELECT_FILE_BY_ITEM_EXPAND);

      let itemsSPResponse: any[] = await items.get();

      let itemsResponse: Array<any> = [];

      if (itemsSPResponse.length > 0) {
        itemsResponse = itemsSPResponse.map((element: any) => {
          return {
            Title: element.File.Name,
            ServerRelativeUrl: element.File.ServerRelativeUrl,
            ServerRedirectedEmbedUri: element.ServerRedirectedEmbedUri,
            UniqueId: element.File.UniqueId,
          };
        });
      }


      return {
        OperationSuccess: true,
        Data: itemsResponse,
      };

    } catch (error) {
      console.error("Error fetching application help files:", error);


      return {
        OperationSuccess: false,
        Data: [],
      };
    }
  };


}
